<template>
  <div>
    <ProgressBar v-if="this.$route.name !== 'end'" />
    <div id="page-intro">
      <div class="page-content">
        <div class="page-title" v-html="contentGeneral.introTitle"></div>
        <div class="page-subtitle" v-html="contentGeneral.introSubtitle"></div>
        <div class="page-txt" v-html="contentGeneral.introText"></div>
        <router-link class="start-now" to="/q/1">
          {{ contentGeneral.strtNw }}
          <svg xmlns="http://www.w3.org/2000/svg" width="22.627" height="33.941" viewBox="0 0 22.627 33.941"><g data-name="Group 900" transform="translate(-1645.858 -831.858)"><g data-name="Rectangle 593" transform="translate(1651.515 831.858) rotate(45)" fill="none" stroke="#3baf29" stroke-width="2"><rect width="24" height="8" rx="4" stroke="none"/><rect x="1" y="1" width="22" height="6" rx="3" fill="none"/></g><g data-name="Rectangle 594" transform="translate(1645.858 860.142) rotate(-45)" fill="none" stroke="#3baf29" stroke-width="2"><rect width="24" height="8" rx="4" stroke="none"/><rect x="1" y="1" width="22" height="6" rx="3" fill="none"/></g></g></svg>
        </router-link>
      </div>
      <div class="page-content">
        <img class="side-image" :src="require('@/assets/images/intro_image.svg')" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/ProgressBar.vue'

export default {
  name: 'intro',
  components: { ProgressBar },
  computed: {
    ...mapGetters([
      'contentGeneral'
    ])
  },
  mounted () {
    this.$store.dispatch('GET_QUESTIONS')
  }
}
</script>

<style lang="scss">
@import '@/assets/_variables';
@import '@/assets/_mixin';
#app {
  display: flex;
  align-items: stretch;
  #page-intro {
    display: flex;
    margin: $pad*4 0 $pad*2 0;

    @media(max-width: $mdm){
      flex-direction: column-reverse;
      margin-top: 0;
    }
    /***************************************************************************
    BACKGROUND IMAGES
    ***************************************************************************/
    .bg-anim-top,
    .bg-anim-bottom {
      position: absolute;
      path {
        fill: $lightBlue;
      }
    }
    .bg-anim-top {
      left: 0;
      top: 0;
      width: 25%;
    }
    .bg-anim-bottom {
      bottom: 0;
      right: $pad*4;
      width: 50%;
    }
    /***************************************************************************
    CONTENT
    ***************************************************************************/
    .page-content {
      bottom: 0;  top: 0;
      margin-top: auto; margin-bottom: auto;
      position: relative;
      width: 50%;
      z-index: 1;

      .side-image {
        display: block;
        width: 225px;
        max-width: 80%;
        margin: auto;
      }

      @media(max-width: $mdm){
        width: 100%;

        .side-image {
          width: 100%;
          max-width: 215px;
          margin-bottom: $pad*2;
        }
      }
      .page-title {
        color: $black;
        font: {
          size: $font_sz*2.25;
          weight: $font_b;
        }
        line-height: 1;
        margin-bottom: $pad/2;
        @media (max-width: $sml){
          font: {
            size: $pad*1.5;
          }
        }
      }
      .page-subtitle {
        font: {
          style: italic;
        }
        margin-bottom: $pad*3;
      }
      .page-txt {
        font: {
          size: $font_sz;
          weight: $font_l;
        }
        margin-bottom: $pad*2;
      }
      .start-now {
        @include btn();
      }
    }
    .start-over {
      display: flex;
      align-items: center;
      padding-right: 10px;
      width: 112px;
      text-decoration: none;
    }
    /***************************************************************************
    IMAGE
    ***************************************************************************/
    .page-image {
      @include img(0,1);
    }
  } // #PAGE-INTRO
} // #APP
</style>
